module.exports = __webpack_public_path__ + "img/subscription-FR.8a0c97ba.png";